import { Routes, Route } from "react-router-dom";

import ProfileSection from "./sections/profileSection";
import СurrentEmployeesSection from "./sections/currentEmployeesSection";
import EmployeeCreateSection from "./sections/employeeCreate";
import FiredEmployeesSection from "./sections/firedEmployeesSection";

function EmployeesApp() {
    const data = JSON.parse(localStorage.getItem("userData") as string);

    return (
        <Routes>
            {!data.isCustomer && (
                <>
                    <Route path="/" element={<СurrentEmployeesSection />} />
                    <Route path='/create' element={<EmployeeCreateSection />} />
                    <Route path='/profile/:id' element={<ProfileSection />} />
                    <Route path='/fired' element={<FiredEmployeesSection />} />
                </>
            )}
        </Routes>
    );
}

export default EmployeesApp;